import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel
} from '@mui/material';
import TablePaginate from 'Components/CustomPagination/TablePaginate';
import { useState } from 'react';
import ApproverListTableBody from './ApproverListTableBody';

export default function ApproverListTable({
  rowsHead,
  rowsData,
  currentPage,
  setCurrentPage,
  handleEditApprover
}) {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');

  const emptyRows =
    currentPage > 0 ? Math.max(0, (1 + currentPage) * rowsPerPage - rowsData.length) : 0;

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] === null || b[orderBy] === undefined) return -1;
    if (a[orderBy] === null || a[orderBy] === undefined) return 1;

    const bValue = String(b[orderBy]).toLowerCase();
    const aValue = String(a[orderBy]).toLowerCase();

    if (bValue < aValue) {
      return -1;
    }
    if (bValue > aValue) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const handleEdit = (row) => {
    handleEditApprover(row);
  };

  const sortedRows = rowsData && [...rowsData]?.sort(getComparator(order, orderBy));

  return (
    <TableContainer
      component={Paper}
      className="approver-management-table-container"
      sx={{ boxShadow: 'none' }}>
      <Table
        className="approver-management-table"
        sx={{ minWidth: 500 }}
        aria-label="custom pagination table">
        <TableHead className="approver-management-table-head" sx={{ borderRadius: '4px' }}>
          <TableRow className="approver-management-table-row">
            {rowsHead.map((column) => (
              <TableCell
                key={column.id}
                component="th"
                scope="row"
                className="approver-management-table-cell"
                sortDirection={orderBy === column.id ? order : false}>
                {column.sortable ? (
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={orderBy === column.id ? order : 'asc'}
                    onClick={() => handleRequestSort(column.id)}>
                    {column.label}
                  </TableSortLabel>
                ) : (
                  column.label
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <ApproverListTableBody
          handleEdit={handleEdit}
          rowsData={rowsData}
          sortedRows={sortedRows}
          emptyRows={emptyRows}
          page={currentPage}
          rowsPerPage={rowsPerPage}
          rowsHead={rowsHead}
          setPage={setCurrentPage}
        />
        <TableRow>
          <TableCell colSpan={rowsHead.length}>
            <TablePagination
              className="pagination-centered"
              rowsPerPageOptions={10}
              count={rowsData.length}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginate}
            />
          </TableCell>
        </TableRow>
      </Table>
    </TableContainer>
  );
}
